import React from 'react'


const Banner = ({ major, N }) => {
  const styleN = N => {
    return N ? " style" + N : ""
  }

  return (
  <section id="banner" 
    className={`${major && "major"}${styleN(N)}`}
  >
    <div className="inner">
      <header className="major">
        <h1>Anywhere Fitness</h1>
      </header>
      <div className="content">
        <p>These days, fitness classes can be held anywhere:<br/> a park, an unfinished basement, or a garage -<br/>not just at a traditional gym! <br/><br/>Certified fitness instructors need an easy way to<br/>take the awkwardness out of attendance taking<br/> and client payment processing.</p>
        <ul className="actions">
          <li><a href="#one" className="button next scrolly">Get Started</a></li>
        </ul>
      </div>
    </div>
  </section>
  )
}

export default Banner
